import React, { useCallback, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { CustomTextField } from '../../../../../../components/TextField';

const AllocatedHours = ({
  data,
  updateCardmutate,
  checkBoardOwnerOrAdmin,
  currentUserId
}) => {

    const [isAllocatedHours, setAllocatedHours] = useState(false);
    const [inputAllocatedHours, setInputAllocatedHours] = useState(data?.allocated_hours);

   // Memoize validation regex
   const numberRegex = useMemo(() => /^[0-9]*\.?[0-9]*$/, []);

   const handleInputHourChange = useCallback((e) => {
    const newValue = e.target.value;
    if (numberRegex.test(newValue)) {
      setInputAllocatedHours(newValue);
    } else {
      setInputAllocatedHours("");
    }
  }, [numberRegex]);

  const handleInputBlur = useCallback( () => {
    if (data?.allocated_hours != parseInt(inputAllocatedHours)) {
      if (
        inputAllocatedHours != undefined &&
        numberRegex.test(parseInt(inputAllocatedHours))
      ) {
        updateCardmutate({
          card_id: data?.card_id,
          data: {
            allocated_hours: inputAllocatedHours,
          },
        });
      }
    } else {
    }
    setAllocatedHours(false);
  },[inputAllocatedHours, data?.card_id,updateCardmutate,numberRegex]);

    const handleKeyDown = useCallback((e) => {
      if (e.key === "Enter") {
        if (data?.allocated_hours != inputAllocatedHours) {
          if (
            inputAllocatedHours !== undefined &&
            inputAllocatedHours !== null &&
            inputAllocatedHours !== ""
          ) {
            e.preventDefault();
            updateCardmutate({
              card_id: data?.card_id,
              data: {
                allocated_hours: inputAllocatedHours,
              },
            });
          }
        }
  
        setAllocatedHours(false);
      }
    },[updateCardmutate,inputAllocatedHours,data?.card_id]);

      const handleAllocatedHoursInput = useCallback (() => {
        if (
          checkBoardOwnerOrAdmin ||
          data?.reporter == currentUserId()
          //  boardPermission?.can_edit_card
        ) {
          setAllocatedHours(true);
          setInputAllocatedHours(data?.allocated_hours);
        }
      },[checkBoardOwnerOrAdmin,data?.reporter,currentUserId,data?.allocated_hours]);

  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Allocated Hours</p>
        <div
          className="taskdetail-sidebar-right-col"
          onClick={handleAllocatedHoursInput}
        >
          {isAllocatedHours ? (
            <CustomTextField
              value={inputAllocatedHours}
              fullWidth
              className="taskdetail-sidebar-right-col"
              size="small"
              variant="outlined"
              onChange={handleInputHourChange}
              onKeyDown={handleKeyDown}
              onBlur={handleInputBlur}
              autoFocus
            />
          ) : (
            <div className="allocated-hours-input">
              {inputAllocatedHours ? (
                <p>{inputAllocatedHours}</p>
              ) : (
                <p className="due-date-input-allocate-hour-none">
                  None
                </p>
              )}
            </div>
          )}
        </div>
      </Grid>
    </div>
  );
};

const isAllocatedHours = (prevProps, nextProps) => {
  return (
   prevProps.data?.allocated_hours === nextProps.data?.allocated_hours 
   &&
   prevProps.data?.card_id === nextProps.data?.card_id
   &&
   prevProps.data?.reporter === nextProps.data?.reporter
  )
}

export default React.memo(AllocatedHours, isAllocatedHours);